export default __webpack_public_path__ + "static/media/img-new-home-3.39b53528.png";